export const otherModule = {
  loadingPay: "Getting payment results",
  goDetail: "Jump order Details"
};
